import { useSardine } from '@/src/services/Sardine'
import { Loading } from '@/src/common/components/Loading'
import { useGetUserInformation } from '@/src/common/hooks/useGetUserInformation'
import { useIsUserSignedIn } from '@/src/common/hooks/useIsUserSignedIn'
import { Stack } from 'expo-router'
import { View } from 'react-native'
import { useEffect } from 'react'

// eslint-disable-next-line
export const unstable_settings = {
  // Ensure that reloading on `/modal` keeps a back button present.
  initialRouteName: 'index',
}

export default function OnboardingLayout() {
  const { loading: tokenStoreLoading } = useIsUserSignedIn()
  const { loading: userInfoLoading } = useGetUserInformation()
  const { updateOptions } = useSardine()

  useEffect(() => {
    void updateOptions({ flow: 'account-creation-init' })
  }, [updateOptions])

  const hideOnboarding = tokenStoreLoading || userInfoLoading

  return (
    <View
      style={{
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      {hideOnboarding && <Loading />}
      <View style={{ display: hideOnboarding ? 'none' : 'flex', flex: 1 }}>
        <LayoutNav />
      </View>
    </View>
  )
}

function LayoutNav() {
  return (
    <Stack>
      <Stack.Screen name="index" options={{ headerShown: false }} />
      <Stack.Screen name="VerifyOTP" options={{ headerShown: false }} />
      <Stack.Screen name="AccountCreation" options={{ headerShown: false }} />
      <Stack.Screen name="AccountCreationVerifyPhoneOtp" options={{ headerShown: false }} />
    </Stack>
  )
}
